<template>
  <div>
    <b-tabs
      v-model="tabIndex"
    >
      <b-tab title="Details">
        <businessDetails />
      </b-tab>
      <b-tab title="Categories & Items">
        <CategoriesAndItems />
      </b-tab>
      <b-tab title="Modifier Groups">
        <ModifierGroups />
      </b-tab>
      <b-tab title="Branches">
        <BusinessBranchesList
          :business-id="businessId"
        />
      </b-tab>
      <b-tab title="Documents">
        <documents
          :business-id="businessId"
          :is-new="false"
        />
      </b-tab>
      <b-tab title="Billing">
        <billing
          :business-id="businessId"
          :is-new="false"
        />
      </b-tab>
      <b-tab title="Tags">
        <BusinessTags :business-id="businessId" />
      </b-tab>
      <b-tab title="Wallet">
        <BusinessWallet />
      </b-tab>

      <b-tab title="Linked Admins">
        <LinkedAdmins />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BTabs, BTab,
} from 'bootstrap-vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import businessStore from '../store'
import CategoriesAndItems from '../components/CategoriesAndItems.vue'
import ModifierGroups from '../components/ModifierGroups.vue'
import BusinessBranchesList from '../components/BusinessBranchesList.vue'
import BusinessTags from '../components/business-tags/BusinessTags.vue'
import businessDetails from '../components/business-details.vue'
import billing from '../components/create-business/billing.vue'
import Documents from '../components/create-business/documents.vue'
import BusinessWallet from '../components/wallet/BusinessWallet.vue'
import LinkedAdmins from '../components/LinkedAdmins.vue'

export default {
  components: {
    BTabs, BTab, CategoriesAndItems, ModifierGroups, BusinessBranchesList, BusinessTags, businessDetails, billing, Documents, BusinessWallet, LinkedAdmins,
  },
  setup(_, ctx) {
    useRegisterStoreModule('business', businessStore)

    const tabIndex = ref(0)
    const businessId = ctx.root.$route.params.id

    return {
      tabIndex,
      businessId,
    }
  },
}
</script>

<style>

</style>
